/* ==========================================================================
   lbl-coffee-valve — 2-Phasen-Loop für die Aromaventil-Infografik.
   Steuert ausschließlich data-phase="warm"|"cold" auf .lbl-coffee-vlv__stage;
   sämtliche Sichtbarkeit/Animation hängt in CSS daran.
   Kurze Warm-Phase → dominante (längere) Kalt-Phase, endlos.
   Der Loop läuft nur, solange die Stage im Viewport ist (Perf/Akku).
   prefers-reduced-motion: statischer Kalt-Endzustand, kein Loop.
   ========================================================================== */
(function () {
  'use strict';

  var WARM_MS = 3400;
  var COLD_MS = 5800;

  function driveStage(stage) {
    var timer = null;
    var running = false;

    function cycle() {
      stage.dataset.phase = 'warm';
      timer = setTimeout(function () {
        stage.dataset.phase = 'cold';
        timer = setTimeout(cycle, COLD_MS);
      }, WARM_MS);
    }

    function start() {
      if (running) return;
      running = true;
      cycle();
    }

    function stop() {
      running = false;
      if (timer) { clearTimeout(timer); timer = null; }
    }

    return { start: start, stop: stop };
  }

  function init() {
    var stages = document.querySelectorAll('.lbl-coffee-vlv__stage[data-phase]');
    if (!stages.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      // Statischer Endzustand: dichtes Ventil, ruhende Aroma-Punkte, keine Bewegung.
      Array.prototype.forEach.call(stages, function (stage) { stage.dataset.phase = 'cold'; });
      return;
    }

    // Ohne IntersectionObserver: einfach dauerhaft loopen.
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(stages, function (stage) { driveStage(stage).start(); });
      return;
    }

    var controllers = new WeakMap();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var ctrl = controllers.get(e.target);
        if (!ctrl) return;
        if (e.isIntersecting) ctrl.start();
        else ctrl.stop();
      });
    }, { threshold: 0.25 });

    Array.prototype.forEach.call(stages, function (stage) {
      controllers.set(stage, driveStage(stage));
      io.observe(stage);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
